<form class="routed-component-layout" [formGroup]="form" novalidate>

  <div class="routed-component-body">
    <div class="routed-component-title-block">
      <h2>{{'REGISTRATION.EXPECTED_ACTIVITY_STEP.DEPOSIT.TITLE' | translate}}</h2>
    </div>

    <div class="callout informative">
      <div class="callout-content">
        <p>{{'REGISTRATION.EXPECTED_ACTIVITY_STEP.DEPOSIT.TIP_TEXT' | translate}}</p>
      </div>
    </div>

    <soldo-field-layout *ngIf="form.get('externalDeposit')"
      [control]="form.controls['externalDeposit']"
      fieldName="externalDeposit"
      cypressSelector="Expected_RadioButton_ExternalDeposit"
      label="REGISTRATION.EXPECTED_ACTIVITY_STEP.DEPOSIT.LABEL">

      <fieldset input>
        <div *ngFor="let option of externalDepositOptions; let i = index" class="radio-item"
          [attr.data-cy]="'Expected_RadioButton_ExternalDeposit_'+option.value">

          <input formControlName="externalDeposit" type="radio" name="externalDeposit" [id]="'externalDepositOption'+i" [value]="option.value">
          <label [for]="'externalDepositOption'+i">{{option.label | translate}}</label>

          <div class="conditional-subfield-container" *ngIf="form.controls['description'] && form.controls['externalDeposit'].value === option.value">

            <soldo-field-layout
            [control]="form.controls['description']"
            label="REGISTRATION.EXPECTED_ACTIVITY_STEP.DEPOSIT.DESCRIPTION_LABEL"
            cypressSelector="Expected_RadioButton_ExternalDeposit_Description"
            fieldName="description">

              <ng-container input>
                <textarea
                name="description"
                formControlName="description"
                type="text"
                maxlength="{{externalDepositDescriptionMaxlength}}"></textarea>

                <character-counter [maxlength]="externalDepositDescriptionMaxlength" [control]="form.controls['description']"></character-counter>

              </ng-container>

                <ng-container errorMessage>
                <soldo-field-error errorName="required">{{ 'REQUIRED' | translate }}</soldo-field-error>
                <soldo-field-error error errorName="maxlength">
                  {{ 'MAX_LENGHT' | translate: { value: form.controls.description.errors?.maxlength?.requiredLength } }}
                </soldo-field-error>

              </ng-container>
            </soldo-field-layout>

          </div>

        </div>
      </fieldset>

      <ng-container errorMessage>
        <soldo-field-error errorName="required">{{ 'REGISTRATION.EXPECTED_ACTIVITY_STEP.DEPOSIT.RANGE_REQUIRED' | translate }}</soldo-field-error>
      </ng-container>

    </soldo-field-layout>
  </div>
  <div class="navigation-controls-layout">
    <div class="routed-component-cta">
      <button type="button" (click)="previousStep()" data-cy="Expected_Button_PreviousStepButton">
        {{ 'REGISTRATION.EXPECTED_ACTIVITY_STEP.PREVIOUS_SUB_STEP_BUTTON' | translate }}
      </button>
      <button type="submit" class="primary" [disabled]="loading" [ngClass]="{ 'loading': loading}"
      (click)="nextStep()" data-cy="Expected_Button_NextStepButton">{{ 'REGISTRATION.EXPECTED_ACTIVITY_STEP.NEXT_SUB_STEP_BUTTON' | translate }}</button>
    </div>
    <save-and-continue-later stepName="Expected External Deposit"></save-and-continue-later>
  </div>

</form>
